import { Cell, Grid, HFlow } from 'bold-ui'
import bridge_logo from 'images/bridge.svg'
import gov_logo from 'images/sobre/logo-gov.png'
import ms_logo from 'images/sobre/logo-ms.svg'
import sus_logo from 'images/sobre/logo-sus.svg'
import ufsc_logo from 'images/sobre/logo-ufsc.svg'
import React from 'react'

interface SobreFooterProps {}

export class SobreFooterView extends React.Component<SobreFooterProps> {
  render() {
    return (
      <div>
        <hr />
        <Grid>
          <Cell size={6}>
            <HFlow hSpacing={1} alignItems='center'>
              <img src={ufsc_logo} alt='Logo da Universidade Federal de Santa Catarina' />
              <img src={bridge_logo} alt='Logo do Laboratório Bridge' />
            </HFlow>
          </Cell>
          <Cell size={6}>
            <HFlow hSpacing={1} alignItems='center' justifyContent='flex-end'>
              <img src={sus_logo} alt='Logo do Sistema Único de Saúde' />
              <img src={ms_logo} alt='Logo do Ministério da Saúde' />
              <img src={gov_logo} alt='Logo do Governo do Brasil' />
            </HFlow>
          </Cell>
        </Grid>
      </div>
    )
  }
}
